
<template>
    <div :class="`section ${grey === 'true' ? 'grey-card' : ''}`">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                
                <v-col xl="3" lg="5" md="6" cols="12" class="d-flex justify-center flex-column">
                <div>
                    <h2 class="section__header-title text-h3 font-weight-bold">{{ title }}</h2>
                    <div>
                        <p class="tagline">{{ subtitle }}</p>
                        <slot name="content"></slot>
                    </div>
                </div>
                </v-col>
                <v-col xl="4" lg="4" md="6" col="12" class="my-auto">
                <div class="d-flex justify-center mb-4 d-lg my-auto">
                    <slot name="img"></slot>
                </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'ChannelsMMS',
    props: [
        'title',
        'subtitle',
        'grey'

  ],
}
</script>

<style lang="scss">
</style>